export const DISPUTE_LINK =
  'https://www.transunion.com/credit-disputes/dispute-your-credit';
